import { notification } from 'antd';
import React from 'react';
import { useNavigate, useParams } from 'react-router';

import { MainLayout } from 'components/Layout/MainLayout';
import { useAppDispatch, useAppSelector } from 'store';
import {
  loadRegulationsItem,
  saveRegulationsItem,
  saveRegulationsItemDraft,
} from 'store/slices/regulations/actions';
import {
  RegulationsItem,
  RegulationsItemRequest,
} from 'store/slices/regulations/interfaces';
import { DeepPartial } from 'types/utils';

import { RegulationsForm } from './components/RegulationsForm';
import { mapValuesToForm } from './components/RegulationsForm/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { item } = useAppSelector(state => state.regulations);
  const isCorrectItem = item?.id === Number(id);

  React.useEffect(() => {
    dispatch(loadRegulationsItem(id));
  }, [id]);

  const onSubmit = (values: RegulationsItemRequest) => {
    setIsLoading(true);
    const newItem = { ...values, id: item?.id };

    dispatch(saveRegulationsItem(newItem))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно обновлена',
        });
        navigate('/regulations');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveAsDraft = (values: DeepPartial<RegulationsItem>) => {
    setIsLoading(true);

    dispatch(saveRegulationsItemDraft({ ...values, id: item?.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно обновлена',
        });
        navigate('/regulations');
      })
      .catch(() => setIsLoading(false));
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {isCorrectItem && (
        <RegulationsForm
          onSubmit={onSubmit}
          isDraft={item.status === 'draft'}
          defaultValues={mapValuesToForm(item)}
          onSaveAsDraft={onSaveAsDraft}
          isLoading={isLoading}
        />
      )}
    </MainLayout>
  );
};
